import React from 'react';
import PropTypes from 'prop-types';
import MUIDataTable from 'mui-datatables';
import { createTheme, ThemeProvider, StyledEngineProvider, adaptV4Theme } from '@mui/material/styles';

const DataTable = (props) => {
	const {
		id,
		title = '',
		data = [],
		columns = [],
		options,
		// pagination = true,
		showDownload = false, // show download icon button
		showPrint = false, // show print icon button
		selectableRows = 'none', // multiple, single, none
		rowsPerPage = 20, // number of rows displayed by page
		filterType = 'multiselect', // filter type can be multiselect, texfield, etc.,
		tableBodyMaxHeight = '40em',
		...rest
	} = props;

	const getMuiTheme = (outerTheme) => {
		const {
			tableBodyCellMaxWidth,
			actionColumnWidth
		} = props;

		return createTheme(adaptV4Theme({
			...outerTheme,
			overrides: {
				MUIDataTable: {},
				MUIDataTableHead: {},
				MUIDataTableHeadCell: {},
				MUIDataTableHeadRow: {},
				MUIDataTableBody: {},
				MUIDataTableBodyRow: {},
				MuiTableCell: {
					body: {
						maxWidth: tableBodyCellMaxWidth,
						'&:last-child': {
							width: actionColumnWidth
						}
					}
				},
				MUIDataTablePagination: {},
				MUIDataTableViewCol: {},
				MUIDataTableSearch: {},
				MUIDataTableToolbar: {},
				MUIDataTableFilter: {},
				MUIDataTableFilterList: {}
			}
		}));
	};

	const _onRowSelection = (currentRowsSelected, allRowsSelected, rowsSelected) => {
		const { onRowSelection } = props;
		const selectedRows = data.filter((dt, index) => rowsSelected.indexOf(index) !== -1);
		onRowSelection(selectedRows);
	};

	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={outerTheme => ({ ...getMuiTheme(outerTheme) })}>
				<div id={id}>
					<MUIDataTable
						key={id}
						title={title}
						data={data}
						columns={columns}
						options={{
							tableBodyMaxHeight,
							rowsPerPageOptions: [10, 15, 20, 100],
							filterType,
							download: showDownload,
							print: showPrint,
							selectableRows,
							responsive: 'standard',
							rowsPerPage,
							onRowSelectionChange: _onRowSelection,
							...options,
						}}
						{...rest}
					/>
				</div>
			</ThemeProvider>
		</StyledEngineProvider>
	);
};

DataTable.propTypes = {
	id: PropTypes.string.isRequired,
	title: PropTypes.string,
	data: PropTypes.array.isRequired,
	columns: PropTypes.array.isRequired,
	options: PropTypes.object,
	pagination: PropTypes.bool,
	showDownload: PropTypes.bool,
	showPrint: PropTypes.bool,
	selectableRows: PropTypes.string,
	rowsPerPage: PropTypes.number,
	filterType: PropTypes.string,
	tableBodyCellMaxWidth: PropTypes.string || PropTypes.number,
	actionColumnWidth: PropTypes.string || PropTypes.number,
	onRowSelection: PropTypes.func,
	tableBodyMaxHeight: PropTypes.string
};

export default DataTable;
